import { type FC, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { sendAnalyticsData, useSportSearchBehavior, useSportUrlParams } from '@mwl/core-lib';
import { Loader } from '@/components/Loader/Loader';
import { routes } from '@/constants';
import { SportSearchEmpty } from './components/SportSearchEmpty/SportSearchEmpty';
import { SportSearchEvents } from './components/SportSearchEvents/SportSearchEvents';
import { SportSearchLines } from './components/SportSearchLines/SportSearchLines';
import { SportSearchResult } from './components/SportSearchResult/SportSearchResult';
import { getAnalytics } from './SportSearch.analytics';
import styles from './SportSearch.module.scss';
const SportSearch: FC = () => {
  const {
    t
  } = useTranslation('sport', {
    keyPrefix: 'search'
  });
  const {
    results,
    enrichedResults,
    isLoading,
    isLoaded
  } = useSportSearchBehavior(routes);
  const {
    search
  } = useSportUrlParams();
  const analyticsData = getAnalytics(search, results?.totalCount);
  useEffect(() => {
    sendAnalyticsData(analyticsData.open.eventName, analyticsData.open.data);
  }, [analyticsData]);
  return <div className={styles.root} data-sentry-component="SportSearch" data-sentry-source-file="SportSearch.tsx">
      {isLoaded && results && results?.totalCount === 0 && <SportSearchEmpty />}
      {isLoading && !isLoaded && <Loader />}
      {isLoaded && !!results?.totalCount && <>
          <p className={styles.countTitle}>
            {t('events_found', 'Events found:')} <span className={styles.count}>{results.totalCount}</span>
          </p>
          {enrichedResults && <>
              <SportSearchEvents events={enrichedResults.events} className={styles.sports} />
              <div className={styles.results}>
                <SportSearchResult searchResults={enrichedResults} variant="sports" />
                <SportSearchResult searchResults={enrichedResults} variant="categories" />
                <SportSearchResult searchResults={enrichedResults} variant="championships" />
                <SportSearchLines searchResultData={results} events={enrichedResults.events} />
              </div>
            </>}
        </>}
    </div>;
};
export { SportSearch };